import { useContext, useEffect, useMemo, useState } from "react";
import CardRadio from "../../components/Form/Radio/CardRadio";
import { radioOptions, stepsData } from "./UserData";
import { Button, Modal } from "antd";
import { StepProgress } from "../../components/StepProgress/StepProgress";
import VehicleDetails from "./VehicleDetails";
import VehicleDetailsBodyOnly from "./VehicleDetailsBodyOnly";
import AgentDetails from "./AgentDetails";
import CompanyDetails from "./CompanyDetails";
import ApplicationPreview from "./ApplicationPreview";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setFloorAppFormDeatils } from "../../redux/slice/newFloorApplication";
import { useForm } from "react-hook-form";
import moment from "moment/moment";

import { ReactComponent as PopupSuccess } from "../../images/popup_success.svg";
import { AuthenticationContext } from "../../App";
import BodyApplicationPreview from "./BodyApplicationPreview";
import { useLocation, useNavigate } from "react-router-dom";
import { CommomPermission } from "../../common/Constants";
import { ServerAPI } from "../../common/ServerAPI";

const DATE_FORMAT = "DD-MM-YYYY";

const DefaultCompletedObj = {
  1: "",
  2: "",
  3: "",
};

const DefaultFormValues = {
  flooring_product: "",
  // seller_name: "",
  vehicle_reg_no: "",
  ownerId_type: "",
  ownerId_last4: "",
  intended_floor_amount: "",
  purchase_price: "",
  make_model: "",
  first_reg_date: "",
  COE_expiry: "",
  COE_value: "",
  yom: "",
  is_opc_vehicle: "0",
  OMV: "",
  engine_no: "",
  chassis_no: "",
  min_parf: "",
  is_vehicle_coe_expiry: "0",
  PQP_renewal_month: "",
  PQP_amount: "",
  is_step1_valid: 0,
  is_draft: 0,
  logCard: [],
  additional: [],
  country_Code: "Singapore",
};
const DefaultBodyOnlyForm = {
  flooring_product: "",
  intended_floor_amount: "",
  purchase_price: "",
  original_reg_date: "",
  yom: "",
  engine_no: "",
  chassis_no: "",
  is_step1_valid: 0,
  is_draft: 0,
  v5_overseas_logcard: [],
  sales_agreement: [],
  data_card: [],
  cargo_clearance_permit: [],
  bill_of_landing: [],
  letter_of_newness: [],
  additional: [],
  vehicle_status: 0,
  is_VAC_ready: 0,
  VAC_number: "",
};

const companyDefaultFomrValues = {
  company: "",
  UEN: "",
  poc1_name: "",
  poc1_email: "",
  poc1_contactno: "",
  poc2_name: "",
  poc2_email: "",
  poc2_contactno: "",
  is_save_future: 0,
  is_step_valid: 0,
  is_draft: 0,
  Company_ACRA: [],
};
const NewFlooringApplication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const floorAppFormDetails = useSelector(
    (state) => state?.newFloorApplication?.floorAppFormDetails
  );
  const { authData } = useContext(AuthenticationContext);

  const AppId = location.state !== null ? location.state?.appId : null;
  const pagePermission = location.state;

  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "flooring")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "flooring-cases");
  const FloorCasesPErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;

  const [retriveLoading, setRetriveLoading] = useState(false);

  const [flooringSettingsData, setFlooringSettingsData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [applicationData, setApplicationData] = useState({});
  const [cartItems, setCarItems] = useState([]);
  const [isStepCompleted, setIsStepCompleted] = useState(
    floorAppFormDetails?.isStepCompleted !== undefined
      ? floorAppFormDetails?.isStepCompleted
      : DefaultCompletedObj
  );
  const [selectedOption, setSelectedOption] = useState({
    form:
      floorAppFormDetails?.form !== undefined
        ? floorAppFormDetails?.form
        : "COE",
    fillUpType:
      floorAppFormDetails?.fillUpType !== undefined
        ? floorAppFormDetails?.fillUpType
        : "Manually",
  });
  const [showStepSection, setShowStepSection] = useState(
    floorAppFormDetails?.showStepSection !== undefined &&
      floorAppFormDetails?.showStepSection !== null
      ? floorAppFormDetails?.showStepSection
      : false
  );
  const [currentSection, setCurrentSection] = useState(
    floorAppFormDetails?.currentSection !== undefined
      ? floorAppFormDetails?.currentSection
      : 1
  );
  const [retriveMessage, setRetriveMessage] = useState({
    type: "",
    message: "",
  });
  const [formValues, setFormValues] = useState(
    floorAppFormDetails?.vehicleInfo !== undefined
      ? floorAppFormDetails?.vehicleInfo
      : DefaultFormValues
  );
  const [bodyOnlyForm, setBodyOnlyForm] = useState(
    floorAppFormDetails?.form === "BODYONLY" &&
      floorAppFormDetails?.form !== undefined
      ? floorAppFormDetails?.vehicleInfo !== undefined
        ? floorAppFormDetails?.vehicleInfo
        : DefaultBodyOnlyForm
      : DefaultBodyOnlyForm
  );

  const [vehicelDetail, setVehicleDetail] = useState({});
  const [vehicleDocumnets, setVehicleDocuments] = useState({});


  const methods = useForm({
    defaultValues: useMemo(() => {
      return floorAppFormDetails?.form !== undefined
        ? floorAppFormDetails?.form === "BODYONLY"
          ? bodyOnlyForm
          : formValues
        : selectedOption?.form === "BODYONLY"
          ? bodyOnlyForm
          : formValues;
    }, [formValues, bodyOnlyForm, floorAppFormDetails, selectedOption]),
  });

  const [companyFormValues, setCompanyFormValues] = useState(
    floorAppFormDetails?.companyInfo !== undefined
      ? floorAppFormDetails?.companyInfo
      : companyDefaultFomrValues
  );
  const companyMethods = useForm({
    defaultValues: useMemo(() => {
      return companyFormValues;
    }, [companyFormValues]),
  });

  const {
    formState: { errors },
    watch,
    getValues,
    setValue,
  } = floorAppFormDetails?.currentSection == 3 ? companyMethods : methods;

  useEffect(() => {
    if (
      floorAppFormDetails?.form !== undefined &&
      floorAppFormDetails?.vehicleInfo !== undefined
    ) {
      if (floorAppFormDetails?.form === "BODYONLY") {
        setBodyOnlyForm(floorAppFormDetails?.vehicleInfo);
      } else {
        setFormValues(floorAppFormDetails?.vehicleInfo);
      }
    }
  }, [floorAppFormDetails]);

  const GetFlooringSettings = async () => {
    const resp = await axios.get("/flooring/settings");
    if (resp.status < 400) {
      setFlooringSettingsData(resp.data?.data);
    }
  };

  const GetApplicationData = async () => {
    const resp = await axios.get(
      `flooring/application/show/${AppId !== null ? AppId : floorAppFormDetails?.appId
      }`
    );
    if (resp?.status < 400) {
      const appData = resp.data?.data;
      setApplicationData(resp.data?.data);

      if (
        appData?.is_companyInfo_future !== undefined &&
        appData?.is_companyInfo_future?.UEN !== null &&
        appData?.is_companyInfo_future?.UEN !== undefined
      ) {
        setCompanyFormValues({
          ...companyDefaultFomrValues,
          ...appData?.is_companyInfo_future,
          is_save_future: appData?.companyInfo?.is_save_future !== undefined ? appData?.companyInfo?.is_save_future : 1,
          Company_ACRA: appData?.Company_ACRA
        });
      } else {
        if (Array.isArray(appData?.companyInfo)) {
          if (authData) {
            setValue("company", authData.name);
            setValue("UEN", authData?.uenNumber);
            setValue("is_save_future", 0)
            authData?.contacts.forEach((item, idx) => {
              setValue(`poc${idx + 1}_name`, item.name);
              setValue(`poc${idx + 1}_email`, item.email);
              setValue(`poc${idx + 1}_contactno`, item.phoneNumber);
            });
          }
        } else {
          delete appData?.companyInfo?.is_valid
          setCompanyFormValues({
            ...appData?.companyInfo,
            is_step_valid: appData?.companyInfo?.is_draft == 0 ? 1 : 0,
            Company_ACRA: appData?.Company_ACRA
          });
        }
      }
      if (appData?.cart !== undefined && appData?.cart?.length > 0) {
        setCarItems(appData?.cart);
      } else {
        setCarItems([]);
      }
    }
  };
  const GetApplicationIncompleteData = async () => {
    const resp = await axios.get(
      `flooring/application/show/${AppId !== null ? AppId : floorAppFormDetails?.appId
      }`
    );
    if (resp?.status < 400) {
      const appData = resp.data?.data;
      const vechInfo = appData?.vehicleInfo;
      const companyInfo = appData?.companyInfo;
      const cart = appData?.cart;
      const step1 = vechInfo?.is_step1_valid;
      const step2 = cart?.length > 0 ? 1 : 0;
      const step3 = Array.isArray(appData?.companyInfo)
        ? 0
        : companyInfo?.is_draft == 0
          ? 1
          : 0;

      const test = step1 == 1 ? (step2 == 1 ? (step3 == 1 ? 4 : 3) : 2) : 1;

      setApplicationData(resp.data?.data);
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            1: step1 == 1,
            2: step2 == 1,
            3: step3 == 1,
          },
        })
      );
      setIsStepCompleted({
        1: step1 == 1,
        2: step2 == 1,
        3: step3 == 1,
      });
      setSelectedOption({
        form: vechInfo?.flooring_product,
        fillUpType: "Manually",
      });
      setCurrentSection(test);
      dispatch(
        setFloorAppFormDeatils({
          appId: AppId,
          showStepSection: true,
          form: vechInfo?.flooring_product,
          fillUpType: "Manually",
          currentSection: test,
          vehicleInfo:
            vechInfo?.flooring_product === "BODYONLY"
              ? {
                ...vechInfo,
                v5_overseas_logcard: appData?.v5_overseas_logcard,
                sales_agreement: appData?.sales_agreement,
                data_card: appData?.data_card,
                cargo_clearance_permit: appData?.cargo_clearance_permit,
                bill_of_landing: appData?.bill_of_landing,
                letter_of_newness: appData?.letter_of_newness,
                additional: appData?.additional,
              }
              : {
                ...vechInfo,
                logCard: appData?.logcard,
                additional: appData?.additional,
                country_Code: "Singapore",
              },
        })
      );
      setShowStepSection(true);
      if (appData?.is_companyInfo_future !== undefined) {
        setCompanyFormValues({
          ...companyDefaultFomrValues,
          ...appData?.is_companyInfo_future,
          is_save_future: 1,
        });
      } else {
        if (Array.isArray(appData?.companyInfo)) {
          if (authData) {
            setValue("company", authData.name);
            authData?.contacts.forEach((item, idx) => {
              setValue(`poc${idx + 1} _name`, item.name);
              setValue(`poc${idx + 1} _email`, item.email);
              setValue(`poc${idx + 1} _contactno`, item.phoneNumber);
            });
          }
        } else {
          setCompanyFormValues(appData?.companyInfo);
        }
      }
      if (appData?.cart !== undefined && appData?.cart?.length > 0) {
        setCarItems(appData?.cart);
      } else {
        setCarItems([]);
      }
      if (vechInfo?.flooring_product === "BODYONLY") {
        setBodyOnlyForm({
          ...vechInfo,
          v5_overseas_logcard: appData?.v5_overseas_logcard,
          sales_agreement: appData?.sales_agreement,
          data_card: appData?.data_card,
          cargo_clearance_permit: appData?.cargo_clearance_permit,
          bill_of_landing: appData?.bill_of_landing,
          letter_of_newness: appData?.letter_of_newness,
          additional: appData?.additional,
        });
      } else {
        setFormValues({
          ...vechInfo,
          logCard: appData?.logcard,
          additional: appData?.additional,
        });
      }
    }
  };

  useEffect(() => {
    if (AppId !== null && showStepSection == false) {
      GetApplicationIncompleteData();
    }
  }, [AppId]);

  const CreateInitialApplication = async () => {
    const data = {
      flooring_product: selectedOption.form,
      fillup_type: selectedOption.fillUpType === "Retrieve Data" ? 0 : 1,
    };
    const resp = await axios.post("/flooring/application/initiate", data);
    if (resp.status < 400) {
      dispatch(
        setFloorAppFormDeatils({
          appId: resp.data?.data?.id,
          showStepSection: true,
          form: selectedOption.form,
          fillUpType: selectedOption.fillUpType,
          currentSection: currentSection,
        })
      );
      toast.success(resp.data?.message);
      setShowStepSection(true);
    }
  };

  const RetriveFormSubmit = async (data) => {
    const dataObj = {
      seller_name: data?.seller_name,
      vehicle_reg_no: data?.vehicle_reg_no,
      ownerId_type: data?.ownerId_type,
      ownerId_last4: data?.ownerId_last4,
    };
    setRetriveLoading(true);

    try {
      // const resp = await axios.post(
      //   `flooring/application/logcard/${floorAppFormDetails?.appId} `,
      //   dataObj
      // );
      const resp = await axios.post(
        `flooring/application/fetch/vehicle/info`, dataObj
      );
      if (resp?.status < 400) {
        if (resp.data?.data?.status !== undefined && !resp.data?.data?.status) {
          toast.error(resp.data?.data?.error_message.pop());
          setRetriveLoading(false);
          return;
        } else {
          if (
            typeof resp.data?.data === "object" &&
            Object.keys(resp.data?.data)?.length > 0
          ) {
            setRetriveMessage({
              type: 1,
              message: resp.data?.message,
            });
            const temp = {
              ...resp.data?.data,
              logCard: Array.isArray(resp.data?.data?.log_card)
                ? resp.data?.data?.log_card
                : [],
              additional: Array.isArray(resp.data?.data?.additional)
                ? resp.data?.data?.additional
                : [],
              country_Code: "Singapore",
              is_vehicle_coe_expiry: resp.data?.data?.PQP_amount !== "" && resp.data?.data?.PQP_amount !== null ? 2 : 0,
              coe_rebate: resp.data?.data?.coe_rebate,
              parf_rebate: resp.data?.data?.parf_rebate,
              total_rebate: resp.data?.data?.total_rebate,
              ...DefaultFormValues



            }
            delete temp?.log_card;

            setFormValues(temp);
            setSelectedOption({
              fillUpType: "Manually",
              form: selectedOption?.form,
            });
            dispatch(
              setFloorAppFormDeatils({
                fillUpType: "Manually",
              })
            );
            toast.success(resp.data?.message);
          } else {
            setRetriveMessage({
              type: 0,
              message: resp.data?.message,
            });
            toast.error(resp.data?.message);
          }
        }
        setRetriveLoading(false);
      } else {
        setRetriveLoading(false);
      }
    } catch (err) {
      setRetriveLoading(false);
    }
  };

  const handleOptionChange = (value) => {
    setSelectedOption({
      ...selectedOption,
      form: value,
    });
  };

  const handleChildOptionChange = (childOptionValue) => {
    setSelectedOption({
      ...selectedOption,
      fillUpType: childOptionValue,
    });
  };

  const RetriveVehicleData = async (vechData) => {
    try {
      const response = await ServerAPI.fileUpload(vechData.file);
      if (response.resp_code == 200) {
        let logCard = [{
          extension: "pdf",
          size: vechData.file.size,
          name: vechData?.vehicle_reg_no + ".pdf",
          path: response.data
        }]
        setFormValues({
          ...formValues,
          ...vechData,
          logCard: logCard
        });
      }
      setVehicleDetail({
        vehicle_reg_no: vechData?.vehicle_reg_no,
        access_code: vechData?.access_code,
        // selling_price: vechData?.selling_price,
        customer_id_type: vechData?.customer_id_type,
        owner_id: vechData?.owner_id,
        make_model: vechData?.make_model,
        opc_vehicle_id: vechData?.opc_vehicle_id,
        vehicle_under_opc: vechData?.vehicle_under_opc,
        vehicle_emission_scheme: vechData?.vehicle_emission_scheme,
        vehicle_coe_category: vechData?.vehicle_coe_category,
        vehicle_coe_amount: vechData?.vehicle_coe_amount,
        vehicle_ori_reg_date: vechData?.vehicle_ori_reg_date,
        vehicle_chassis_no: vechData?.vehicle_chassis_no,
        vehicle_engine_no: vechData?.vehicle_engine_no,
        vehicle_omv: vechData?.vehicle_omv,
        vehicle_yom: vechData?.vehicle_yom,
        coe_rebate: vechData?.coe_rebate,
        parf_rebate: vechData?.parf_rebate,
        total_rebate: vechData?.total_rebate
      });
    } catch (err) {
      toast.error("Vehicle details not fetched..!");
    }
  };

  const SubmitIncompleteForm = async (data) => {
    const dataObj = {
      vehicleInfo: {
        ...data,
        is_step1_valid: 0,
        is_draft: 1,
        country_Code: data?.ownerId_type === "3" ? data?.country_Code : "",
        flooring_product: floorAppFormDetails?.form,
        first_reg_date:
          data[`first_reg_date`] !== "" && data[`first_reg_date`] !== null
            ? moment(data[`first_reg_date`], DATE_FORMAT).format(
              DATE_FORMAT
            ) === data[`first_reg_date`]
              ? data["first_reg_date"]
              : moment(data[[`first_reg_date`]])?.format("DD-MM-YYYY")
            : "",

        [`COE_expiry`]:
          data[`COE_expiry`] !== "" && data[`COE_expiry`] !== null
            ? moment(data[`COE_expiry`], DATE_FORMAT).format(DATE_FORMAT) ===
              data[`COE_expiry`]
              ? data["COE_expiry"]
              : moment(data[[`COE_expiry`]])?.format("DD-MM-YYYY")
            : "",
        [`COE_value`]: data[[`COE_value`]],
      },
      logcard: data?.logCard,
      additional: data?.additional,
    };
    const resp = await axios.post(
      `flooring/application/update/${floorAppFormDetails?.appId} `,
      dataObj
    );
    if (resp.status < 400) {
      GetApplicationData();
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        1: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            1: false,
          },
          vehicleInfo: getValues(),
        })
      );
    }
  };

  const onSubmitSections1 = async (data, section) => {
    if (data?.logCard?.length < 1) {
      toast.error("Please upload a Logcard file");
      return;
    } else {
      const dataObj = {
        vehicleInfo: {
          ...data,
          is_step1_valid: 1,
          is_draft: 0,
          country_Code: data?.ownerId_type === "3" ? data?.country_Code : "",
          flooring_product: floorAppFormDetails?.form,
          first_reg_date:
            data[`first_reg_date`] !== "" && data[`first_reg_date`] !== null
              ? moment(data[`first_reg_date`], DATE_FORMAT).format(
                DATE_FORMAT
              ) === data[`first_reg_date`]
                ? data["first_reg_date"]
                : moment(data[[`first_reg_date`]])?.format("DD-MM-YYYY")
              : "",
          [`COE_expiry`]:
            data[`COE_expiry`] !== "" && data[`COE_expiry`] !== null
              ? moment(data[`COE_expiry`], DATE_FORMAT).format(DATE_FORMAT) ===
                data[`COE_expiry`]
                ? data["COE_expiry"]
                : moment(data[[`COE_expiry`]])?.format("DD-MM-YYYY")
              : "",
          [`COE_value`]: data[[`COE_value`]],
        },
        logcard: data.logCard,
        additional: data?.additional,
      };
      const resp = await axios.post(
        `flooring/application/update/${floorAppFormDetails?.appId} `,
        dataObj
      );
      if (resp.status < 400) {
        GetApplicationData();

        toast.success(resp.data?.message);
        dispatch(
          setFloorAppFormDeatils({
            isStepCompleted: {
              ...isStepCompleted,
              1: true,
            },
            vehicleInfo: getValues(),
            currentSection:
              section == 4
                ? Object.values({
                  ...isStepCompleted,
                  1: true,
                })
                  ?.filter((it) => it !== "")
                  ?.reduce((sum, next) => sum && next, true)
                  ? 4
                  : currentSection
                : section,
          })
        );
        setCurrentSection(
          section == 4
            ? Object.values({
              ...isStepCompleted,
              1: true,
            })
              ?.filter((it) => it !== "")
              ?.reduce((sum, next) => sum && next, true)
              ? 4
              : currentSection
            : section
        );
        setIsStepCompleted({
          ...isStepCompleted,
          1: true,
        });
      }
    }
  };

  const SubmitBodyOnlyIncompleteForm = async (data) => {
    const dataObj = {
      vehicleInfo: {
        ...data,
        is_step1_valid: 0,
        is_draft: 1,
        original_reg_date:
          data.original_reg_date !== ""
            ? moment(data.original_reg_date)?.format("DD-MM-YYYY")
            : "",
      },
      v5_overseas_logcard: data?.v5_overseas_logcard,
      sales_agreement: data?.sales_agreement,
      data_card: data?.data_card,
      cargo_clearance_permit: data?.cargo_clearance_permit,
      bill_of_landing: data?.bill_of_landing,
      letter_of_newness: data?.letter_of_newness,
      additional: data?.additional,
    };
    const resp = await axios.post(
      `flooring/application/update/${floorAppFormDetails?.appId} `,
      dataObj
    );
    if (resp.status < 400) {
      GetApplicationData();
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        1: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            1: false,
          },
          vehicleInfo: getValues(),
        })
      );
    }
  };

  const onSubmitBodyOnlyFomr = async (data, section) => {
    if (
      data?.v5_overseas_logcard?.length < 1 ||
      data?.sales_agreement?.length < 1 ||
      data?.data_card?.length < 1 ||
      data?.cargo_clearance_permit?.length < 1 ||
      data?.bill_of_landing?.length < 1 ||
      data?.letter_of_newness?.length < 1
    ) {
      toast.error("Please upload essential Documents");
      return;
    } else {
      const dataObj = {
        vehicleInfo: {
          ...data,
          is_step1_valid: 1,
          is_draft: 0,
          original_reg_date: moment(data.original_reg_date)?.format(
            "DD-MM-YYYY"
          ),
        },
        v5_overseas_logcard: data?.v5_overseas_logcard,
        sales_agreement: data?.sales_agreement,
        data_card: data?.data_card,
        cargo_clearance_permit: data?.cargo_clearance_permit,
        bill_of_landing: data?.bill_of_landing,
        letter_of_newness: data?.letter_of_newness,
        additional: data?.additional,
      };
      const resp = await axios.post(
        `flooring/application/update/${floorAppFormDetails?.appId} `,
        dataObj
      );
      if (resp.status < 400) {
        GetApplicationData();
        toast.success(resp.data?.message);
        dispatch(
          setFloorAppFormDeatils({
            isStepCompleted: {
              ...isStepCompleted,
              1: true,
            },
            vehicleInfo: getValues(),
            currentSection:
              section == 4
                ? Object.values({
                  ...isStepCompleted,
                  1: true,
                })
                  ?.filter((it) => it !== "")
                  ?.reduce((sum, next) => sum && next, true)
                  ? 4
                  : currentSection
                : section,
          })
        );
        setCurrentSection(
          section == 4
            ? Object.values({
              ...isStepCompleted,
              1: true,
            })
              ?.filter((it) => it !== "")
              ?.reduce((sum, next) => sum && next, true)
              ? 4
              : currentSection
            : section
        );
        setIsStepCompleted({
          ...isStepCompleted,
          1: true,
        });
      }
    }
  };

  const SubmitCompanyIncompleteForm = async (data) => {
    const dataObj = {
      companyInfo: {
        ...data,
        is_step_valid: 0,
        is_draft: 1,
      },
      Company_ACRA: data.Company_ACRA,
    };
    const resp = await axios.post(
      `flooring/application/company/${floorAppFormDetails?.appId} `,
      dataObj
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        3: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            3: false,
          },
          companyInfo: getValues(),
        })
      );
    }
  };

  const CompanySubmit = async (data, section) => {
    const dataObj = {
      companyInfo: {
        ...data,
        is_step_valid: 1,
        is_draft: 0,
      },
      Company_ACRA: data.Company_ACRA,
    };
    const resp = await axios.post(
      `flooring/application/company/${floorAppFormDetails?.appId} `,
      dataObj
    );
    if (resp.status < 400) {
      GetApplicationData();
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        3: true,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            3: true,
          },
          currentSection:
            section == 4
              ? Object.values({
                ...isStepCompleted,
                3: true,
              })
                ?.filter((it) => it !== "")
                ?.reduce((sum, next) => sum && next, true)
                ? 4
                : currentSection
              : section,
          companyInfo: getValues(),
        })
      );
      setCurrentSection(
        section == 4
          ? Object.values({
            ...isStepCompleted,
            3: true,
          })
            ?.filter((it) => it !== "")
            ?.reduce((sum, next) => sum && next, true)
            ? 4
            : currentSection
          : section
      );
      if (
        section == 4 &&
        !Object.values({
          ...isStepCompleted,
          3: true,
        })
          ?.filter((it) => it !== "")
          ?.reduce((sum, next) => sum && next, true)
      ) {
        toast.error("Complete all the steps to look at the preview");
      }
    }
  };

  const FinalLoanSubmit = async () => {
    const resp = await axios.post(
      `/flooring/application/submit/${floorAppFormDetails?.appId} `
    );
    if (resp.status < 400) {
      setIsModalVisible(true);
      toast.success(resp.data?.message);
    } else {
      toast.error("Application not submitted");
      setIsModalVisible(false);
    }
  };

  const Step2Validation = (items, section) => {
    setIsStepCompleted({
      ...isStepCompleted,
      2: items?.length > 0,
    });
    dispatch(
      setFloorAppFormDeatils({
        isStepCompleted: {
          ...isStepCompleted,
          2: items?.length > 0,
        },
        currentSection:
          section == 4
            ? Object.values({
              ...isStepCompleted,
              2: items?.length > 0,
            })
              ?.filter((it) => it !== "")
              ?.reduce((sum, next) => sum && next, true)
              ? 4
              : currentSection
            : section,
      })
    );
    setCurrentSection(
      section == 4
        ? Object.values({
          ...isStepCompleted,
          2: items?.length > 0,
        })
          ?.filter((it) => it !== "")
          ?.reduce((sum, next) => sum && next, true)
          ? 4
          : currentSection
        : section
    );
    toast.success("Your Agent Details has been updated!.");
    if (
      section == 4 &&
      !Object.values({
        ...isStepCompleted,
        2: items?.length > 0,
      })
        ?.filter((it) => it !== "")
        ?.reduce((sum, next) => sum && next, true)
    ) {
      toast.error("Complete all the steps to look at the preview");
    }
  };

  const handleCurrentSectionChange = (section, prevSection) => {
    if (prevSection == 1) {
      if (floorAppFormDetails?.form === "BODYONLY") {
        if (
          Object.values(getValues())?.filter((it) => it !== "" && it !== null)
            ?.length >=
          Number(`${getValues("is_VAC_ready") == 1 ? 19 : 18} `) &&
          getValues("v5_overseas_logcard")?.length > 0 &&
          getValues("sales_agreement")?.length > 0 &&
          getValues("bill_of_landing")?.length > 0 &&
          getValues("cargo_clearance_permit")?.length > 0 &&
          getValues("data_card")?.length > 0 &&
          getValues("letter_of_newness")?.length > 0
        ) {
          onSubmitBodyOnlyFomr(getValues(), section);
        } else {
          SubmitBodyOnlyIncompleteForm(getValues());
          if (section == 4) {
            if (
              floorAppFormDetails?.isStepCompleted !== undefined &&
              Object.values(floorAppFormDetails?.isStepCompleted)
                ?.filter((it) => it !== "")
                ?.reduce((sum, next) => sum && next, true)
            ) {
              setCurrentSection(section);
              dispatch(
                setFloorAppFormDeatils({
                  currentSection: section,
                })
              );
            } else {
              toast.error("Complete all the steps to look at the preview");
              setCurrentSection(prevSection);
              dispatch(
                setFloorAppFormDeatils({
                  currentSection: prevSection,
                })
              );
              return;
            }
          } else {
            setCurrentSection(section);
            dispatch(
              setFloorAppFormDeatils({
                currentSection: section,
              })
            );
          }
        }
      } else {
        if (
          getValues("intended_floor_amount") !== "" &&
          getValues("intended_floor_amount") !== null &&
          getValues("intended_floor_amount") !== "0.00"
        ) {
          const temp = getValues();
          delete temp.id;
          delete temp.application_uniqueId;
          if (
            Object.values(temp)?.filter(
              (it) => it !== "" && it !== null && it !== undefined
            )?.length >=
            Number(`${watch("is_vehicle_coe_expiry") == 2 ? 24 : 22} `) &&
            watch("logCard")?.length > 0
          ) {
            onSubmitSections1(getValues(), section);
          } else {
            const values = getValues();
            SubmitIncompleteForm(values);
            if (section == 4) {
              if (
                floorAppFormDetails?.isStepCompleted !== undefined &&
                Object.values(floorAppFormDetails?.isStepCompleted)
                  ?.filter((it) => it !== "")
                  ?.reduce((sum, next) => sum && next, true)
              ) {
                setCurrentSection(section);
                dispatch(
                  setFloorAppFormDeatils({
                    currentSection: section,
                  })
                );
              } else {
                toast.error("Complete all the steps to look at the preview");
                setCurrentSection(prevSection);
                dispatch(
                  setFloorAppFormDeatils({
                    currentSection: prevSection,
                  })
                );
                return;
              }
            } else {
              setCurrentSection(section);
              dispatch(
                setFloorAppFormDeatils({
                  currentSection: section,
                })
              );
            }
          }
        } else {
          toast.warn(
            "Please enter Intended Floor Amount to move on to further steps."
          );
          return;
        }
      }
    } else if (prevSection == 2) {
      Step2Validation(cartItems, section);
    } else if (prevSection == 3) {
      if (
        Object.values(getValues())?.filter((it) => it !== "" && it !== null)
          ?.length >= 12 &&
        watch("Company_ACRA")?.length > 0
      ) {
        CompanySubmit(getValues(), section);
      } else {
        SubmitCompanyIncompleteForm(getValues());
        if (prevSection == 3 && section == 4) {
          if (
            floorAppFormDetails?.isStepCompleted !== undefined &&
            Object.values(floorAppFormDetails?.isStepCompleted)
              ?.filter((it) => it !== "")
              ?.reduce((sum, next) => sum && next, true)
          ) {
            setCurrentSection(section);
            dispatch(
              setFloorAppFormDeatils({
                currentSection: section,
              })
            );
          } else {
            toast.error("Complete all the steps to look at the preview");
            return;
          }
        } else {
          setCurrentSection(section);
          dispatch(
            setFloorAppFormDeatils({
              currentSection: section,
            })
          );
        }
        return;
      }
    } else {
      setCurrentSection(section);
      dispatch(
        setFloorAppFormDeatils({
          currentSection: section,
        })
      );
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (floorAppFormDetails?.isStepCompleted !== undefined) {
      setIsStepCompleted(floorAppFormDetails?.isStepCompleted);
    }
    if (
      floorAppFormDetails?.appId !== undefined &&
      floorAppFormDetails?.appId !== ""
    ) {
      GetApplicationData(floorAppFormDetails?.appId);
    }
  }, [floorAppFormDetails]);

  useEffect(() => {
    GetFlooringSettings();
  }, []);

  return (
    <section className="common_container">
      <header className="common-header flex justify-between">
        <div className="common-header-body">
          <h1>New Flooring application</h1>
        </div>
      </header>
      {!showStepSection && (
        <section className="application-section">
          <h2 className="app-heading">What is the vehicle you are flooring</h2>
          <CardRadio
            options={radioOptions}
            selectedOption={selectedOption?.form}
            onOptionChange={handleOptionChange}
            childSelectedOption={selectedOption?.fillUpType}
            onChildOptionChange={handleChildOptionChange}
          />
          <div className="footer-btn-block">
            {pagePermission?.create_permission == 1 && (
              <Button
                type="button"
                className="sav_btn"
                disabled={selectedOption?.fillUpType == null}
                onClick={() => {
                  console.log(selectedOption)
                  CreateInitialApplication();
                }}
              >
                Next
              </Button>
            )}
          </div>
        </section>
      )}
      {selectedOption && showStepSection && (
        <StepProgress
          currentSection={currentSection}
          totalSections={stepsData.length}
          onCurrentSectionChange={handleCurrentSectionChange}
          finalAction={FinalLoanSubmit}
          stepsData={stepsData}
          backClass="can_btn"
          nextClass="sav_btn"
          actionClass="sav_btn"
          actionName="Apply for Flooring"
          isStepCompleted={isStepCompleted}
        >
          <section className="application-step-section">
            {currentSection === 1 && (
              <>
                {selectedOption?.form === "BODYONLY" ? (
                  <VehicleDetailsBodyOnly
                    selectedOption={selectedOption?.form}
                    onSubmit={onSubmitBodyOnlyFomr}
                    formValues={bodyOnlyForm}
                    methods={methods}
                    ApplicationId={floorAppFormDetails?.appId}
                    setIsStepCompleted={setIsStepCompleted}
                    isStepCompleted={isStepCompleted}
                    DefaultBodyOnlyForm={DefaultBodyOnlyForm}
                  />
                ) : (
                  <VehicleDetails
                    setShowStepSection={setShowStepSection}
                    selectedOption={selectedOption.form}
                    childSelectedOption={selectedOption.fillUpType}
                    formValues={formValues}
                    onSubmit={onSubmitSections1}
                    RetriveFormSubmit={RetriveFormSubmit}
                    OwnerIdData={flooringSettingsData?.OwnerIDType}
                    retriveMessage={retriveMessage}
                    methods={methods}
                    ApplicationId={floorAppFormDetails?.appId}
                    setIsStepCompleted={setIsStepCompleted}
                    isStepCompleted={isStepCompleted}
                    setSelectedOption={setSelectedOption}
                    retriveLoading={retriveLoading}
                    DefaultFormValues={DefaultFormValues}
                    RetriveVehicleData={RetriveVehicleData}
                    RetriveVehicleDetails={vehicelDetail}
                    vehicleDocumnets={vehicleDocumnets}
                  />
                )}
              </>
            )}
            {currentSection === 2 && (
              <AgentDetails
                ApplicationId={floorAppFormDetails?.appId}
                applicationData={applicationData}
                GetApplicationInfo={GetApplicationData}
                cartItems={cartItems}
                Step2Validation={Step2Validation}
              />
            )}
            {currentSection === 3 && (
              <CompanyDetails
                ApplicationId={floorAppFormDetails?.appId}
                onSubmit={CompanySubmit}
                formValues={companyFormValues}
                methods={companyMethods}
                setIsStepCompleted={setIsStepCompleted}
                isStepCompleted={isStepCompleted}
                currentSection={currentSection}
                DefaultCompletedObj={DefaultCompletedObj}
              />
            )}
            {currentSection === 4 && (
              <>
                {selectedOption?.form === "BODYONLY" ? (
                  <BodyApplicationPreview
                    applicationData={applicationData}
                    flooringSettingsData={flooringSettingsData}
                  />
                ) : (
                  <ApplicationPreview
                    applicationData={applicationData}
                    OwnerIdData={flooringSettingsData?.OwnerIDType}
                    flooringSettingsData={flooringSettingsData}
                  />
                )}
              </>
            )}
          </section>
        </StepProgress>
      )}

      <Modal
        open={isModalVisible}
        onCancel={closeModal}
        centered
        width={520}
        footer={null}
      >
        <div className="common-success-block">
          <span className="mb-2">
            <PopupSuccess />
          </span>
          <h2>Application has been submitted</h2>
          <p>
            Your can view the application in Flooring Cases Page to check for
            agent response
          </p>
          <Button
            type="button"
            className="sav_btn"
            onClick={() => {
              navigate("/flooring-cases", {
                state: { ...FloorCasesPErmission }
              });
            }}
          >
            View Flooring Case
          </Button>
          <span
            className="close-tab"
            onClick={() => {
              closeModal();
            }}
          >
            Close Tab
          </span>
        </div>
      </Modal>
    </section>
  );
};
export default NewFlooringApplication;
